import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import charOvershootRotateInGif from '../../../assets/images/transitions/charOvershootRotateIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_CHAR_OVERSHOOT_ROTATE_IN = 'charOvershootRotateIn';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const charOvershootRotateInPresetDetails = {
  // The name of the preset.
  name: PRESET_CHAR_OVERSHOOT_ROTATE_IN,

  // A human friendly name for the preset.
  humanName: 'Character - Overshoot & Rotate In',

  // A preview of the transition.
  gif: charOvershootRotateInGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'letter.scaleY': {
      time: {
        end: 'start.1000',
        start: 'start.0'
      },
      easing: EASINGS.easeOutElastic,
      values: [
        0,
        1
      ],
      stagger: 20,
      staggerDuration: false,
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_CHAR_OVERSHOOT_ROTATE_IN,
    options: {},
  },
};

charOvershootRotateInPresetDetails.template.options = lodash.cloneDeep(charOvershootRotateInPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_CHAR_OVERSHOOT_ROTATE_IN;

// This defines the value of the presets object.
export default charOvershootRotateInPresetDetails;
